import styled from 'styled-components';

export const BreadcrumbContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;

  button {
    display: flex;
    align-items: center;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 10px;

    li {
      color: light-dark(#101113, var(--mantine-color-dark-0));
      display: flex;
      align-items: center;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 140%; /* 19.6px */
      span {
        max-width: 550px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      a {
        color: #228be6;
        text-decoration: none;
      }

      svg {
        margin-top: 2px;
      }

      &.current {
        span {
          color: var(--mantine-color-text);
        }
      }

      &.future {
        span {
          color: light-dark(#868e96, var(--mantine-color-dark-2));
        }
      }
    }
  }
`;
